import { Image as ImageBase } from "@wix/design-system";
import React from "react";
import { getImageSrc } from "./../../wix-rich-content-common/lib/imageUtils.js";
const Image = ({
  src,
  height,
  width,
  requiredHeight,
  requiredWidth,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    ImageBase,
    {
      fit: "contain",
      style: { minHeight: requiredHeight, height: requiredHeight },
      src: getImageSrc(
        {
          file_name: src,
          id: src,
          width,
          height
        },
        void 0,
        {
          requiredWidth,
          requiredHeight,
          requiredQuality: 80
        }
      ),
      borderRadius: 0,
      ...props
    }
  );
};
export {
  Image
};
//# sourceMappingURL=image.js.map
